import React from 'react';
import {Props, createFilter, components, ActionMeta} from 'react-select';
import {Option} from 'react-select/src/filters';
import {ErrorType} from '../../../utils/common';
import {SelectOptionType} from '../../../utils/types';
// import Loader from '../Loader';
import {ErrorMessage} from '../../../styled/common';
import {Wrapper, DisplayIcon, Label, LoaderWrapper, styles, ReactSelect} from './styled';

const Control = (props: any) => {
  const {label, name, error, invalid, isDisabled} = props.selectProps;
  return (
    <Wrapper
      className="control-wrapper"
      invalid={invalid || Boolean(error)}
      disabled={isDisabled}
    >
      {label && <Label>{label}</Label>}
      <components.Control {...props} />
      {error && <ErrorMessage data-testid={`${name}-error`}>{error}</ErrorMessage>}
    </Wrapper>
  );
};

const DropdownIndicator = (props: any) => {
  return (
    <components.DropdownIndicator {...props}>
      <DisplayIcon shouldRotate={props.selectProps.isMenuOpen} />
    </components.DropdownIndicator>
  );
};

const LoadingIndicator = () => {
  return <LoaderWrapper />;
};

const Input = (props: any) => {
  return <components.Input {...props} autoComplete="on" />;
};

export type SelectProps = Omit<Props, 'isDisabled' | 'onChange'> & {
  onChange?: (option: Option, info: ActionMeta<SelectOptionType>) => void;
  label?: string;
  invalid?: boolean;
  disabled?: boolean;
  error?: ErrorType;
  empty?: boolean;
};

const defaultProps: Partial<SelectProps> = {
  label: '',
  invalid: false,
  placeholder: '- -',
  error: '',
  isSearchable: true,
  openMenuOnFocus: true,
};

function StyledSelect({
  onChange,
  label,
  invalid,
  error,
  className,
  disabled,
  loading,
  tooltip,
  components,
  onMenuOpen,
  onMenuClose,
  empty,
  ...props
}: SelectProps) {
  const onChangeHandler = disabled ? undefined : onChange;
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const handleMenuOpen = React.useCallback(() => {
    setIsMenuOpen(true);
    onMenuOpen?.();
  }, [onMenuOpen]);

  const handleMenuClose = React.useCallback(() => {
    setIsMenuOpen(false);
    onMenuClose?.();
  }, [onMenuClose]);

  return (
    <ReactSelect
      empty={empty || !props.value}
      autoComplete="on"
      className={`${className} select`}
      classNamePrefix="select"
      error={error}
      label={label}
      invalid={invalid}
      onChange={onChangeHandler}
      isDisabled={disabled}
      isLoading={loading}
      onMenuOpen={handleMenuOpen}
      onMenuClose={handleMenuClose}
      isMenuOpen={isMenuOpen}
      filterOption={createFilter({ignoreAccents: false})}
      components={{
        Control,
        IndicatorSeparator: null,
        DropdownIndicator,
        LoadingIndicator,
        Input,
        ...components,
      }}
      styles={styles}
      {...props}
    />
  );
}

StyledSelect.defaultProps = defaultProps;
export {StyledSelect, Control, DropdownIndicator, LoadingIndicator, Input};
